<div class="weaveTagsContainer">
  <label>{{label}}</label>
  <mat-form-field class="weaveTags" appearance="fill">
    <mat-chip-grid #chipGrid  aria-label="Tag selection">
      @for (tag of tags; track tag) {
        <mat-chip-row
          (removed)="removeTag(tag)">
          {{tag.name}}
          <button matChipRemove>
            <img src="/assets/img/icons/svg/delete_circle_outline_white.svg" alt="remove tag" class="removeTagIcon">
          </button>
        </mat-chip-row>
      }
      <input
        placeholder="{{placeholder}}"
        #tagInput
        [formControl]="tagsCtrl"
        [matChipInputAddOnBlur]="false"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addTag($event)"
        >
      </mat-chip-grid>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTag($event)" class="tagsAutocomplete">
        @for (tag of filteredTags | async; track tag) {
          <mat-option [value]="tag.requestKey" [disabled]="tag.selected" [ngClass]="{'selected':tag.selected}">
            {{tag.name}}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
